"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sheet = exports.rule = exports.nano = exports.keyframes = void 0;
var _nanoCss = require("nano-css");
var _cache = require("nano-css/addon/cache");
var _stable = require("nano-css/addon/stable");
var _nesting = require("nano-css/addon/nesting");
var _keyframes = require("nano-css/addon/keyframes");
var _rule = require("nano-css/addon/rule");
var _sheet = require("nano-css/addon/sheet");
var _prefixer = require("nano-css/addon/prefixer");
// import { createElement } from "react";
// import { addon as addonAtoms } from "nano-css/addon/atoms";
// import { addon as addonJsx } from "nano-css/addon/jsx";

var nano = exports.nano = (0, _nanoCss.create)({
  pfx: 'mko'
  // h: createElement
});

// Add addons you would like to use.
(0, _cache.addon)(nano);
(0, _stable.addon)(nano);
(0, _nesting.addon)(nano);
// addonAtoms(nano);
(0, _keyframes.addon)(nano);
(0, _rule.addon)(nano);
(0, _sheet.addon)(nano);
(0, _prefixer.addon)(nano);
// addonJsx(nano);

var rule = exports.rule = nano.rule,
  sheet = exports.sheet = nano.sheet,
  keyframes = exports.keyframes = nano.keyframes;

// Export everything.